"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deal = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Deal = exports.Deal = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})({
  zIndex: 1
});
//# sourceMappingURL=styles.js.map